<template>
  <div></div>
</template>

<script>
export default {
  name: 'plot-item',

  mounted() {
    // TODO this event should be rework. Too much call to updateCurrentMission and event set-plot-config too much emited
    // WARNING : test both numerical and analytical
    this.$root.$emit('set-plot-config', this.config, this.$el)
    if (this.root.$refs.plotConfig != null) {
      this.root.$refs.plotConfig.updateCurrentMission()
      this.root.$refs.plotConfig.updatePlotData(true)
    }
  },

  props: {
    config: Object,
    root: Object,
    gridlayout: Array
  }
}
</script>

<style scoped></style>
